import React from 'react';
import { Button } from '@noths/polaris-design-system-core-components';

import * as styles from './MediaCountPill.styles';

export interface MediaCountPillProps {
  onClick: () => void;
  totalMedia: number;
}

export const MediaCountPill = ({ onClick, totalMedia }: MediaCountPillProps) => {
  return (
    <Button
      compact
      css={styles.root}
      iconRight="actionForward"
      onClick={onClick}
      secondary
      type="button"
    >
      View all photos ({totalMedia})
    </Button>
  );
};
